import { render, staticRenderFns } from "./noticeListNew.vue?vue&type=template&id=430a0798&scoped=true"
import script from "./noticeListNew.vue?vue&type=script&lang=js"
export * from "./noticeListNew.vue?vue&type=script&lang=js"
import style0 from "./noticeListNew.vue?vue&type=style&index=0&id=430a0798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430a0798",
  null
  
)

export default component.exports